// Centralized feature flags for frontend
// Toggle dashboard behavior in one place
//
// PRODUCTION: All users go to /command-center (unified Command Center dashboard)
// Legacy dashboards are disabled and redirect to /command-center

const env = process.env;

export const FeatureFlags = {
  ENABLE_STRIPE_DASHBOARD: parseBoolEnv('REACT_APP_ENABLE_STRIPE_DASHBOARD', false), // Disabled by default to match production
};

export const { ENABLE_STRIPE_DASHBOARD } = FeatureFlags;

// Dashboard routing map - ALL roles go to Command Center in production
// Include both normalized roles and backend roles for compatibility
export const dashboardRoutes = {
  gc: '/command-center',
  sc: '/command-center',
  admin: '/command-center',
  orgAdmin: '/command-center',
  broker: '/command-center',
  underwriter: '/command-center',
  industrial: '/command-center',
  contractor: '/command-center',      // Backend role mapping
  subcontractor: '/command-center',   // Backend role mapping
  // Individual account types
  foreman: '/command-center',
  safety_supervisor: '/command-center',
  worker: '/command-center',           // Workers use unified Command Center (no separate worker dashboard exists)
};

function parseBoolEnv(name, defaultValue) {
  const v = env[name];
  if (v === 'true') return true;
  if (v === 'false') return false;
  return defaultValue;
}

// Return whether a dashboard is enabled (env-driven with sensible defaults)
// In production, contractor dashboards are ENABLED (they all go to /command-center)
// Broker/underwriter dashboards are disabled unless explicitly enabled
export function isDashboardEnabled(key) {
  if (env.REACT_APP_ENABLEALL_DASHBOARDS === 'true') return true;

  // Contractor roles always enabled - they go to unified Command Center
  // Include both normalized roles (gc, sc), backend roles (contractor, subcontractor),
  // and individual account types (foreman, safety_supervisor, worker)
  const enabledRoles = ['gc', 'sc', 'admin', 'orgAdmin', 'industrial', 'contractor', 'subcontractor', 'foreman', 'safety_supervisor', 'worker'];
  if (enabledRoles.includes(key)) {
    return true;
  }

  // Broker/underwriter dashboards disabled by default (require explicit enablement)
  const flags = {
    broker: parseBoolEnv('REACT_APP_ENABLEBROKER', false),
    underwriter: parseBoolEnv('REACT_APP_ENABLE_UNDERWRITER', false),
  };

  return Boolean(flags[key]);
}

// Compute the set of enabled dashboards and their routes
export function getAvailableRoutes() {
  const out = {};
  for (const [key, route] of Object.entries(dashboardRoutes)) {
    if (isDashboardEnabled(key)) out[key] = route;
  }
  return out;
}
